<!--
  This component is made to be used in different pages
  and paths of the program and it is tried to be written
  in the simplest possible way so that the programmers
  of this program do not run into development problems.

  - Here we have a link that is styled as a button and
    set up so that when called, it receives input for
    internal content and receives a second input to
    display the icon, and finally t
    his component is displayed.
 -->

<a [href]="href">
  {{body}}
  <i [class]="btnClass"></i>
</a>